import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse, useUpdate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IFipixEventDetail, IFipixEventForm } from "interfaces";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FipixEventForm } from "./components";

export const EditFipixEvent: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate, isLoading: isUpdatingEvent } = useUpdate();
  const navigate = useNavigate();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IFipixEventDetail>({
    resource: "fipix/events",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

	const onSubmit = (values: IFipixEventForm) => {
    const submitValues = { ...values };
		const id = params?.id;
		if (id) {
			mutate(
				{
					resource: "fipix/events",
					id: id,
					meta: {
						ignoreResourceWrapper: true,
					},
					values: {
						...submitValues,
					},
				},
				{
					onSuccess: () => {
						toast.success("Edit successfully");
						navigate(`/fipix/events/${id}`);
					},
				}
			);	
		}
  };

  const fipixEventDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Fipix event" />
      {fipixEventDetailData ? (
        <FipixEventForm
          defaultData={fipixEventDetailData}
          id={params?.id}
					onSubmit={onSubmit}
        />
      ) : (
        <></>
      )}
      {((isFetching && isPreviousData) || isUpdatingEvent) ? <FullScreenLoading /> : <></>}
    </div>
  );
};
